import React from "react";
import {Grid} from "@mui/material";
import {Button} from "../../Buttons/Button";
import {Colors} from "../../../resources/Colors";


export function GoToDemoSection(){

    return <>
        <Grid container display={"flex"} justifyContent={"center"} alignItems={"center"} style={{backgroundColor: Colors.bioretisBlueLight , minHeight:'20vh'}} >
            <Grid className="goToDemoSectionGrid" display={"flex"} justifyContent={"center"} alignItems={"center"} item xs={12}>
                <h1 className={'go_to_demo_h1'}>Do you want to see more about iCAP?</h1>
            </Grid>
            <Grid className="goToDemoSectionGrid" display={"flex"} justifyContent={"center"} alignItems={"center"} item xs={12}>
                <Button buttonStyle={"btn--outline--dark"} buttonSize={'btn--large'} onClick={() => window.location.href='/immunoclust-demo'} >show me more</Button>
            </Grid>

        </Grid>


    </>
}export default GoToDemoSection